import { render } from "./PaginationRedesigned.vue?vue&type=template&id=0a7aa078&scoped=true"
import script from "./PaginationRedesigned.vue?vue&type=script&lang=js"
export * from "./PaginationRedesigned.vue?vue&type=script&lang=js"

import "./PaginationRedesigned.vue?vue&type=style&index=0&id=0a7aa078&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7aa078"]])

export default __exports__